import "../../css/login.css";

import { Button, Grid, Typography } from "@material-ui/core";
import ReactCodeInput from "react-verification-code-input";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import classNames from "classnames";
import { Link } from "react-router-dom";
import { Cookies } from "react-cookie";

import CountDownComponent from "../countDown";
import CountryCode from "../countryCode";
import Logo from "../logoWithText";
import Snackbar from "../snackbar";
import Loading from "../loading";
import { styles } from "./styles.js";
import InputFormat from "../../partials/inputForm";
import {
  _parsePhoneNumber,
  getNumberOnString,
} from "../../partials/validateNumber";
import { _checkRequired, _pick, version } from "../../utils/setting";
import ChangeLanguage from "../changeLanguage";
const cookie = new Cookies();
class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      user: {
        username: "",
        password: "",
        countryCode: this.props.defaultCountryCode || "+84",
        activeCode: "",
        password: "",
      },
      dialog: "login",
      open: true,
      color: "rgba(0, 0, 0, 0.54)",
      openPicker: false,
      listRoles: [],
      valid: {},
      expiredTime: 0,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.defaultCountryCode !== this.props.defaultCountryCode &&
      !this.props.defaultCountryCode
    ) {
      let { user } = this.state;
      user.countryCode = nextProps.defaultCountryCode;
      this.setState({ user: user });
    }
  }
  changeStep = (step) => {
    this.setState({ step: step });
  };
  handleChangeActiveCode = (value) => {
    let user = this.state.user;
    user.activeCode = value;
    this.setState({ user });
  };
  handleChange = (e) => {
    let target = e.target;
    let name = target.name;
    let value =
      name == "username" ? getNumberOnString(target.value) : target.value; // Nếu là username thì chỉ lấy chữ số
    const { t } = this.props;
    let user = this.state.user;
    user[name] = value;
    let valid = {};
    if (name === "username" || name === "countryCode") {
      let validPhone = _parsePhoneNumber(user.countryCode, user.username)
        .isValid;
      if (!validPhone) {
        valid.username = {
          invalid: true,
          message: `${user.countryCode + " " + user.username} ${t(
            "is_invalid_phone"
          )}`,
        };
      }
    }

    this.setState({ user, valid });
  };

  handleCountryCode = (name, value) => {
    let user = this.state.user;
    user[name] = value;
    this.setState({ user });
  };

  handleSnackBar = (message, type) => {
    this.mSnackbar.handleClick(message, type);
  };

  countdownStart() {
    if (this.countdown) {
      this.countdown.start();
    }
    return;
  }
  sendActiveCode = async (e) => {
    const _this = this;
    const { t } = this.props;
    let { user, step } = this.state;

    this.loading.startLoading();
    if (_parsePhoneNumber(`${user.countryCode}`, `${user.username}`).isValid) {
      let check = await this.props.createForgetPassword(user);

      if (check.code === 1) {
        let expiredTime = check.data.expired
          ? Number(check.data.expired) - new Date().getTime()
          : 0;
        this.setState(
          {
            expiredTime: expiredTime,
          },
          function () {
            if (step === 2) _this.countdownStart();
          }
        );
        if (!e) {
          setTimeout(function () {
            _this.setState({ step: step + 1 });
          }, 1000);
        }
      } else {
        if (check.error === 1017) {
          this.handleSnackBar(t("login_user_not_found"), "error");
        } else {
          this.handleSnackBar(check.message, "error");
        }
      }
    } else {
      this.handleSnackBar(t("Login_phone_number_is_not_valid"), "warning");
    }

    this.loading.stopLoading();
  };

  checkActiveCode = async () => {
    this.loading.startLoading();
    const { t } = this.props;
    let { user, step } = this.state;
    user.eventType = "forgetPassword";
    let check = await this.props.checkActiveCode(user);

    if (check.code) {
      this.setState({ step: step + 1 });
    } else {
      // ERROR_ACTIVECODE_EXPIRED
      if (check.error === 1116) {
        this.handleSnackBar(t("active_code_expired"), "error");
      } else if (check.error === 1117 || check.error === 1123) {
        //ERROR_ACTIVECODE_INCORRECT:1117 and ACTIVE_CODE_NOT_FOUND:1116
        this.handleSnackBar(
          t("login_active_code_is_not_correct_please_enter_activecode_again"),
          "error"
        );
      } else {
        this.handleSnackBar(check.message, "error");
      }
    }
    this.loading.stopLoading();
  };
  handleSubmit = () => {
    const { t } = this.props;
    let { user, step } = this.state;

    if (step === 1) {
      this.sendActiveCode();
    } else if (step === 2) {
      this.checkActiveCode();
    } else if (step === 3) {
      this.handleResetPassword();
    }
  };

  handleResetPassword = async () => {
    this.loading.startLoading();
    const { t } = this.props;
    let { user, step } = this.state;
    if (
      !user.password ||
      user.password.length < 6 ||
      !user.confirmPassword ||
      user.confirmPassword.length < 6
    ) {
      this.handleSnackBar(
        t("login_enter_your_new_password_that_more_than_6_character"),
        "warning"
      );
    } else {
      let check = await this.props.userDispatch.forgetPassword(user);
      if (check.code === 1) {
        this.setState({ step: step + 1 });
      } else if (check.error === 1153)
        this.handleSnackBar(t("login_password_not_match"), "error");
      else {
        this.handleSnackBar(
          t("login_change_password_unsuccessfully") + " " + check.message,
          "error"
        );
      }
    }
    this.loading.stopLoading();
  };

  render() {
    const { t, classes, i18n } = this.props;
    const { user, step, valid, expiredTime } = this.state;
    let number = _parsePhoneNumber(user.countryCode, user.username)
      .format_internal;
    return (
      <div className="login-wrapper">
        <Loading onRef={(id) => (this.loading = id)} />
        <Snackbar onRef={(snackbar) => (this.mSnackbar = snackbar)} />
        <ChangeLanguage />
        <div className="login-container">
          <div
            className={classes.logo}
            onClick={() => this.props.history.push("/")}
          >
            <Logo />
          </div>
          <div className={classes.process}>
            <Grid container spacing={3}>
              <Grid item md={12}>
                <Typography className={classes.titleProcess}>
                  {step === 1
                    ? t("register_your_informations")
                    : step === 2
                    ? t("register_verification")
                    : step === 3
                    ? t("login_new_password")
                    : t("login_change_password_successfully")}
                </Typography>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={4}>
                  <div className={classes.boxStep}>
                    <div
                      className={classNames(classes.step, classes.stepActive)}
                    >
                      1
                    </div>
                    <div
                      className={classNames(classes.line, classes.activeLine)}
                    ></div>
                  </div>
                </Grid>
                <Grid item xs={4}>
                  <div className={classes.boxStep}>
                    <div
                      className={classNames(
                        classes.step,
                        step > 1 ? classes.stepActive : ""
                      )}
                    >
                      2
                    </div>
                    <div
                      className={classNames(
                        classes.line,
                        step > 1 ? classes.activeLine : ""
                      )}
                    ></div>
                  </div>
                </Grid>
                <Grid item xs={4}>
                  <div className={classes.boxStep}>
                    <div
                      className={classNames(
                        classes.step,
                        step > 2 ? classes.stepActive : ""
                      )}
                    >
                      3
                    </div>
                    <div
                      className={classNames(
                        classes.line,
                        step > 2 ? classes.activeLine : ""
                      )}
                    ></div>
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </div>
          <div className={classes.container}>
            {step === 1 ? (
              <Grid container spacing={3} alignItems="center">
                <Grid item xs={12}>
                  <Typography className={classes.textGray}>
                    {t("forgot_enter_your_phone_below")}.
                  </Typography>
                </Grid>
                <Grid item xs={5} sm={5} md={4}>
                  <CountryCode
                    margin="normal"
                    code={user.countryCode}
                    handleCountryCode={this.handleCountryCode}
                  />
                </Grid>
                <Grid item xs={7} sm={7} md={8}>
                  <InputFormat
                    required
                    label={t("login_phone_number")}
                    placeholder={t("login_phone_number")}
                    name={"username"}
                    autoComplete="off"
                    margin="normal"
                    value={user.username}
                    onChange={this.handleChange}
                  />
                </Grid>
                {valid.username && valid.username.message ? (
                  <div
                    className={classNames(
                      classes.customValid,
                      `${
                        valid.username && valid.username.invalid
                          ? "invalid"
                          : "valid"
                      }-feedback text-left d-block`
                    )}
                  >
                    {valid.username ? valid.username.message : ""}
                  </div>
                ) : (
                  <div
                    className={classNames(
                      classes.customInValid,
                      `text-left d-block`
                    )}
                  ></div>
                )}
              </Grid>
            ) : step === 2 ? (
              <Grid container spacing={3} justify="center">
                <Grid item xs={12}>
                  <Typography className={classes.textGray}>
                    {t("register_we_sent_code_to")}
                    <span className={classes.phone}> {number}</span>.
                  </Typography>
                  <Typography className={classes.textGray}>
                    {t("register_enter_code_below")}.
                  </Typography>
                </Grid>
                <Grid
                  container
                  item
                  xs={12}
                  justify="center"
                  alignItems="center"
                >
                  <InputFormat style={{ display: "none" }} />
                  <ReactCodeInput
                    onChange={this.handleChangeActiveCode}
                    onComplete={this.checkActiveCode}
                    value={user.activeCode}
                    fieldWidth={60}
                    fieldHeight={54}
                    autoFocus={true}
                  />
                  <div className={classes.message}>
                    <div
                      className={`${
                        valid.activeCode && valid.activeCode.invalid
                          ? "invalid"
                          : "valid"
                      }-feedback text-left d-block`}
                    >
                      {valid.activeCode ? valid.activeCode.message : ""}
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12}>
                  <CountDownComponent
                    onRef={(id) => (this.countdown = id)}
                    expiredTime={expiredTime}
                    resend={this.sendActiveCode}
                    sendDiffentPhone={() => this.changeStep(1)}
                  />
                </Grid>
              </Grid>
            ) : step === 3 ? (
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Typography className={classes.textGray}>
                    {t(
                      "login_enter_your_new_password_that_more_than_6_character"
                    )}
                    .
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <InputFormat
                    required
                    margin="none"
                    value={user.password}
                    name={"password"}
                    label={t("login_new_password")}
                    type="password"
                    fullWidth
                    autoComplete="off"
                    onChange={this.handleChange}
                  />

                  <div className={classes.message}>
                    <div
                      className={`${
                        valid.password && valid.password.invalid
                          ? "invalid"
                          : "valid"
                      }-feedback text-left d-block`}
                    >
                      {valid.password ? valid.password.message : ""}
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12}>
                  <InputFormat
                    required
                    margin="none"
                    value={user.confirmPassword}
                    name={"confirmPassword"}
                    label={t("login_confirm_new_password")}
                    type="password"
                    fullWidth
                    autoComplete="off"
                    onChange={this.handleChange}
                  />

                  <div className={classes.message}>
                    <div
                      className={`${
                        valid.confirmPassword && valid.confirmPassword.invalid
                          ? "invalid"
                          : "valid"
                      }-feedback text-left d-block`}
                    >
                      {valid.confirmPassword
                        ? valid.confirmPassword.message
                        : ""}
                    </div>
                  </div>
                </Grid>
              </Grid>
            ) : (
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Typography className={classes.textGray}>
                    {t(
                      "forgot_create_password_success_pls_login_with_new_password"
                    )}
                    .
                  </Typography>
                </Grid>
              </Grid>
            )}
            {/* ------------------Button------------------ */}
            <Grid
              container
              justify="center"
              alignItems="center"
              className={classes.btnBottom}
              spacing={3}
            >
              {step === 1 || step === 4 ? (
                <Grid item xs={12}>
                  {step === 1 ? (
                    <Button
                      variant="contained"
                      size="large"
                      type="submit"
                      fullWidth
                      color="secondary"
                      onClick={this.handleSubmit}
                      className={classes.button}
                    >
                      {t("next")}
                    </Button>
                  ) : (
                    <Link to="/signin">
                      <Button
                        variant="contained"
                        size="large"
                        type="submit"
                        fullWidth
                        color="secondary"
                        className={classes.button}
                      >
                        {t("register_go_to_sign_in")}
                      </Button>
                    </Link>
                  )}
                </Grid>
              ) : (
                <Grid item md={12}>
                  <Button
                    variant="contained"
                    size="large"
                    type="submit"
                    fullWidth
                    color="secondary"
                    onClick={this.handleSubmit}
                    className={classes.button}
                  >
                    {step === 3 ? t("forgot_create_password") : t("next")}
                  </Button>
                </Grid>
              )}
            </Grid>
            {step < 3 && (
              <Grid
                container
                spacing={3}
                justify="center"
                alignItems="center"
                style={{ marginTop: 16 }}
              >
                <Link to="/signin">
                  <p className="text-gray">
                    {t("have_an_account")}
                    <span className="text-blue">&nbsp;{t("sign_in")}</span>
                  </p>
                </Link>
              </Grid>
            )}
          </div>
        </div>
        <div className="bottom-version">v {version}</div>
      </div>
    );
  }
}

Login.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  expired: state.activeCode.expired,
  defaultCountryCode: state.setting.setting
    ? state.setting.setting.defaultCountryCode
    : "+84",
});

const mapDispatch = (dispatch) => ({
  userDispatch: dispatch.user,
  login: dispatch.user.login,
  createForgetPassword: dispatch.activeCode.createForgetPassword,
  checkActiveCode: dispatch.activeCode.checkActiveCode,
});
export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles, { withTheme: true })(Login)));
